module.exports = __webpack_public_path__ + "assets/img/news_banner.cbb4df6f.png";